import PropTypes from 'prop-types'
import styled from 'styled-components'

const Styled = styled.div`

  .highlight {
    color: #C21110;
  }

  .pizza-card {
    // background: url('/images/supercard/v2/cards-graphics-bg.svg');
    background-image: url(${props => props.bgimage});
    background-size: cover;
    padding-top: 25px;
    padding-bottom: 25px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border: 1px solid #F0F0F0;
    .sc-img {
      min-height: 130px;
    }
  }

  .pizza-card-footer {
    padding-top: 25px;
    padding-bottom: 25px;
    background: #FFFFFF;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`

export const StyledSuperCard = ({ bgimage, children }) => {
  return (<Styled bgimage={bgimage}>{children}</Styled>)
}

StyledSuperCard.propTypes = {
  children: PropTypes.any,
  bgimage: PropTypes.string
}
